import React, { useState, useEffect } from 'react';
import moment from 'moment';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import ContainerFichaOrdemColeta from './components/ContainerFichaOrdemColeta';
import Loading from '../../../components/Loading/Loading';
import NovaOrdem from './NovaOrdem';
//Api
import rotaColeta_api from '../../../api/rotaColeta_api';
import programacaoColeta_api from '../../../api/programacaoColeta_api';
//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

export default function FichaOrdemDeColeta({ ordemColeta, btnVoltar, permissao }) {
    //Estado de controle dos dados da rota
    const [rota, setRota] = useState(null);

    //Estado de controle dos dados da ordem de coleta
    const [ordem, setOrdem] = useState(null);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle da tela de edição
    const [editar, setEditar] = useState(false);

    //Carrega os dados da rota da ordem de coleta
    const loadItemsOrdem = () => {
        setLoading(true);
        if (ordemColeta.idOrdem === 0) {

            ordemColeta.id = ordemColeta.idOrdem;
            ordemColeta.tbRotaColeta_Id = ordemColeta.idRota;
            ordemColeta.dataColeta = ordemColeta.dataColeta;
            ordemColeta.status = ordemColeta.statusOrdem;
            ordemColeta.motorista = ordemColeta.tbUsuarios_Operador_Nome;
            ordemColeta.tbUsuarios_Operador_Id = ordemColeta.tbUsuarios_Operador_Id;

            rotaColeta_api.GetItem(ordemColeta.tbRotaColeta_Id).then(response => {
                response.data.tbVeiculos_Id = response.data.tbVeiculos_Id.toString();
                response.data.tbDestinos_Id = response.data.tbDestinos_Id.toString();
                ordemColeta.tbVeiculos_Id = response.data.tbVeiculos_Id;
                ordemColeta.tbDestinos_Id = response.data.tbDestinos_Id;

                ordemColeta.statusRota = response.data.status;
                ordemColeta.descricao = response.data.descricao;
                ordemColeta.tbVeiculos_Placa = response.data.placaVeiculo;
                ordemColeta.tbDestinos_Fantasia = response.data.fantasiaDestino;
                setRota(response.data);
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));

            programacaoColeta_api.GetListGeradoresProgramacaoOrdem(ordemColeta.id, ordemColeta.dataColeta, ordemColeta.tbRotaColeta_Id, 0).then(response => {
                response.data = response.data.map(value => {
                    const localidade = ordemColeta.items.filter(g => g.idLocalidade === value.idLocalidade);
                    if (localidade.length === 0) {
                        value.cnpj = mascaras.cpfcnpjMask(value.cnpj);
                        value.enderecoLabel = value.cnpj + " | " + value.fantasia + " | " + value.endereco;
                        const localidade = {
                            sequencia: value.sequencia,
                            status: value.statusItem,
                            tbGeradores_Id: value.idGerador,
                            tbGeradorLocalidade_id: value.idLocalidade,
                            cnpj: value.cnpj,
                            idetificacaoLocalidade: value.fantasia,
                            enderecoCompleto: value.endereco,
                            enderecoLabel: value.enderecoLabel,
                            tbTipoColeta_Descricao: value.tipoColeta,
                            tbTipoColeta_Id: value.idTipoColeta,
                            latitude: value.latitude,
                            longitude: value.longitude,
                            excluido: false,
                        }
                        return localidade;
                    }
                });

                ordemColeta.items = response.data;
                setOrdem(ordemColeta);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            })
        } else {
            programacaoColeta_api.GetItem(ordemColeta.idOrdem).then(response => {
                response.data.tbVeiculos_Id = response.data.tbVeiculos_Id.toString();
                response.data.tbDestinos_Id = response.data.tbDestinos_Id.toString();
                response.data.items.map(value => {
                    value.cnpj = mascaras.cpfcnpjMask(value.cnpj);
                })
                setOrdem(response.data);
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }
    const onClickEditar = () => {
        setEditar(true);
    }

    //Carrega os dados da rota assim que o componente é iniciado
    useEffect(() => {
        loadItemsOrdem();
    }, []);
    if (editar) {
        return <NovaOrdem rota={rota} ordemColeta={ordem} btnVoltar={btnVoltar} permissao={permissao} />
    }
    return (
        <MainCard btnVoltar={btnVoltar} btnEditar={onClickEditar}>
            {loading && <Loading />}
            {ordem === null
                ?
                <></>
                :
                <ContainerFichaOrdemColeta ordemColeta={ordem} />
            }
        </MainCard>
    )
}